// @flow
export const LOGIN: string = 'login';
export const PASSWORD: string = 'password';
export const NEW_PASSWORD: string = 'newPassword';
export const AXIOS_INSTANCE: string = 'axiosInstance';
export const ERROR: string = 'error';
export const LOADING: string = 'loading';
export const REMEMBER: string = 'remember';
export const TOKEN: string = 'token';
export const CHANGE_PASSWORD_MODAL_VISIBLE: string = 'changePasswordModalVisible';

export const CLEAR_MESSAGE: string = 'clear_message';
export const CHOSE_PROJECT: string = 'chose_project';
export const CHOSE_PROJECT_SUCCESS: string = 'chose_project_success';
export const CHOSE_PROJECT_FAIL: string = 'chose_project_fail';
export const SIGN_IN: string = 'sign_in';
export const SIGN_IN_SUCCESS: string = 'sign_in_success';
export const SIGN_IN_FAIL: string = 'sign_in_fail';
export const INITIAL_PASSWORD_CHANGED: string = 'initialPasswordChanged';
export const SIGN_OUT: string = 'sign_out';
export const REGISTER_GUEST: string = 'register_guest';
export const REGISTER_GUEST_SUCCESS: string = 'register_guest_success';
export const REGISTER_GUEST_FAIL: string = 'register_guest_fail';
export const CLEAR_PROJECT: string = 'clear_chosen_project';
export const GET_PROJECTS: string = 'append_user_projects';
export const SET_PROJECT: string = 'set_project'; 

export type AuthAction = {
  type: string,
  login?: string,
  password?: string,
  error?: string,
  axiosInstance?: any,
  remember?: boolean
};

export type AuthProps = {
  [LOGIN]: string,
  [ERROR]: string,
  [LOADING]: boolean,
  [AXIOS_INSTANCE]: any,
  [REMEMBER]: boolean,
  signIn: (login: string, password: string, remember: boolean) => {},
  signOut: () => {}
};

export type Project = {
  createdByUserId: number,
  createdByUserName: string,
  createdDateTime: string,
  customerId: number,
  description: string,
  id: number,
  modifiedByUserName: string,
  modifiedDateTime: string,
  name: string,
}


// WEBPACK FOOTER //
// ./src/types/auth.jsx